import React from 'react';
import useStyles from './styles';
import clsx from 'clsx';
const Avatar = ({ alt, src, title, size = 'small', customClassName = '', inlineStyles = {}, }) => {
    const classes = useStyles();
    const containerStyle = clsx({
        [classes.container]: true,
        [customClassName]: Boolean(customClassName),
        [classes[size]]: true
    });
    return (React.createElement("div", { className: containerStyle, style: inlineStyles },
        React.createElement("img", { className: classes.image, alt: alt, src: src, title: title })));
};
export { Avatar };
//# sourceMappingURL=Avatar.js.map